import { render, staticRenderFns } from "./blEdit.vue?vue&type=template&id=250cb88b&scoped=true&lang=html&"
import script from "./blEdit.vue?vue&type=script&lang=js&"
export * from "./blEdit.vue?vue&type=script&lang=js&"
import style0 from "./blEdit.vue?vue&type=style&index=0&id=250cb88b&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "250cb88b",
  null
  
)

export default component.exports